import { makeRequest } from "../api";
import { Model, NameValuePair, QueryableField, Action } from "../types";

export const requestForm = async (
  formType: string,
  bearerString: string,
  fromData: object,
  requestType?: string,
  select?: QueryableField[],
  readonlyColumns?: Action["readonly_columns"],
  label?: string,
  navigateUrl?: string,
  filters?: NameValuePair[],
  actionId?: string,
) => {
  return makeRequest<{}, Model>(
    formType,
    fromData,
    bearerString,
    requestType,
    select,
    readonlyColumns,
    filters,
    undefined,
    label,
    navigateUrl,
    actionId,
  ).then((data) => data);
};
